import { combineReducers } from "redux";
import { LandingPageSlice } from "./LandingPage/LandingPageSlice"

const rootReducer = combineReducers({
  landingPage: LandingPageSlice.reducer,
});

export default rootReducer;
